module.exports = __webpack_public_path__ + "img/back.cbe2efbd.png";